import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const LargeGcgCircularProgress = () => {
    return <CircularProgress size={60} color="primary" />
}

export default LargeGcgCircularProgress
